import React, { createContext, useState, useContext } from 'react';

interface CartContextType {
  selectedVideos: string[];
  addToCart: (videoId: string) => void;
  removeFromCart: (videoId: string) => void; 
  clearCart: () => void;
  isInCart: (videoId: string) => boolean;
}

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedVideos, setSelectedVideos] = useState<string[]>([]);

  const addToCart = (videoId: string) => {
    if (!selectedVideos.includes(videoId)) {
      setSelectedVideos([...selectedVideos, videoId]);
    }
  };

  const removeFromCart = (videoId: string) => {
    setSelectedVideos(selectedVideos.filter(id => id !== videoId));
  };

  const clearCart = () => {
    setSelectedVideos([]);
  };

  const isInCart = (videoId: string) => {
    return selectedVideos.includes(videoId);
  };

  return (
    <CartContext.Provider 
      value={{
        selectedVideos,
        addToCart,
        removeFromCart,
        clearCart,
        isInCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = (): CartContextType => {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};